// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import './public/public.css'

import axios from './axios'
Vue.config.productionTip = false


import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.use(ElementUI);
Vue.prototype.$axios=axios;

//路由拦截 
router.beforeEach((to, from, next) => {
  // let token=sessionStorage.getItem("token");
  if (to.meta.title) {
      document.title = to.meta.title
  }
  next(); 
  console.log(sessionStorage.getItem('token'))
  if(to.path=='/admin'){
     if(sessionStorage.getItem('token')){
        next("/admin/show");
      }
    console.log(11111)
    next();
  }else{
    if(sessionStorage.getItem('token')){
      next();
    }else{
      next('/admin');
    }
    next();
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js